<template>

    <b-modal
        id="game-modal"
        size="md"
        :title="action === 'add' ? 'Przypisz grę' : 'Edytuj grę'"
        ok-title="Zapisz"
        cancel-title="Anuluj"
        ok-variant="success"
        no-close-on-backdrop
        @ok="gameModalHandleOk"
        @hidden="gameModalHandleHide">
        <form @submit.prevent="submitGameForm" @keydown="form.errors.clear($event.target.name)" ref="game-form">

            <div class="row">

                <div class="col-md-6">

                    <div class="form-group">
                        <label for="game_display_name">Nazwa wyświetlana</label>
                        <input type="text" class="form-control" id="game_display_name" v-model="form.display_name" v-on:change="setGameOutputIdentifierName()" @input="validateDisplayNameCharInput($event)">
                        <small class="form-text text-muted">Tłumaczenie w bazowym języku pakietu<strong>{{ packageLanguage !== null ? (' (' + packageLanguage.toUpperCase() + ')') : '' }}</strong>.</small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('display_name')" v-text="form.errors.get('display_name')"></span>
                    </div>

                    <div class="form-group">
                        <label for="game_display_description">Opis wyświetlany</label>
                        <textarea class="form-control" rows="3" id="game_display_description" v-model="form.display_description" @input="validateDisplayDescriptionCharInput($event)"></textarea>
                        <small class="form-text text-muted">Tłumaczenie w bazowym języku pakietu<strong>{{ packageLanguage !== null ? (' (' + packageLanguage.toUpperCase() + ')') : '' }}</strong>.</small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('display_description')" v-text="form.errors.get('display_description')"></span>
                    </div>

                    <div class="form-group">
                        <label for="game_output_identification_name">Identyfikator wewnętrzny</label>
                        <input type="text" class="form-control" id="game_output_identification_name" v-model="form.output_identification_name" @input="validateOutputIdentificationNameCharInput($event)">
                        <small class="form-text text-muted" v-if="action === 'edit'">Zmiana spowoduje modyfikację kluczy tłumaczeń w repozytorium, jednak wszystkie tłumaczenia zostaną zachowane.</small>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('output_identification_name')" v-text="form.errors.get('output_identification_name')"></span>
                    </div>

                    <div class="form-group">
                        <label for="game_location">Położenie</label>
                        <select class="form-control" id="game_location" v-model="form.set_id">
                            <option :value="null" disabled selected>Wybierz</option>
                            <option v-for="location in setLocations" :value="location.id">{{ location.text }}</option>
                        </select>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('set_id')" v-text="form.errors.get('set_id')"></span>
                    </div>

                </div>

                <div class="col-md-6">

                    <div class="form-group">
                        <label>Ikona</label>
                        <file-manager-image-select :input-name="'icon'" v-model="form.icon" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="240/320" :width="240"></file-manager-image-select>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('icon')" v-text="form.errors.get('icon')"></span>
                        <a href="#" class="d-inline-block mt-2 load-icon-from-raw-repo" @click="loadIconFromRawRepository">Wczytaj ikonę z repozytorium źródłowego</a>
                    </div>

                    <div class="mb-4">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="game_autoenter" v-model="form.autoenter">
                            <label class="custom-control-label" for="game_autoenter" style="font-size: 0.875rem; line-height: 1.6;">Autoenter</label>
                        </div>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('autoenter')" v-text="form.errors.get('autoenter')"></span>
                    </div>

                    <div class="mb-4">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="presentation_game" v-model="form.presentation_game">
                            <label class="custom-control-label" for="presentation_game" style="font-size: 0.875rem; line-height: 1.6;">Gra personalizowana</label>
                        </div>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('presentation_game')" v-text="form.errors.get('presentation_game')"></span>
                    </div>

                    <div class="mb-4">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="game_ignore_screensaver" v-model="form.ignore_screensaver">
                            <label class="custom-control-label" for="game_ignore_screensaver" style="font-size: 0.875rem; line-height: 1.6;">Ignoruj wygaszacz ekranu</label>
                        </div>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('ignore_screensaver')" v-text="form.errors.get('ignore_screensaver')"></span>
                    </div>

                    <div class="form-group">
                        <label for="game_input_identification_name">Identyfikator źródłowy</label>
                        <input type="text" class="form-control" id="game_input_identification_name" v-model="form.input_identification_name">
                        <span class="error mt-2 text-danger" v-if="form.errors.has('input_identification_name')" v-text="form.errors.get('input_identification_name')"></span>
                    </div>

                    <div class="form-group">
                        <label for="editor">Edytor</label>
                        <select class="form-control" id="editor" v-model="form.editor">
                            <option :value="null">Brak</option>
                            <option v-for="editorOption in editorOptions" :value="editorOption.id">{{ editorOption.text }}</option>
                        </select>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('editor')" v-text="form.errors.get('editor')"></span>
                    </div>

                </div>

            </div>

            <hr>

            <div class="form-group">
                <label for="game_tags_ids">Tagi</label>
                <select2 id="game_tags_ids" :options="tagsOptions" v-model="form.tags_ids" :settings="tagsSelect2Settings" multiple></select2>
                <b-button size="sm" class="mt-1" @click="copyTags">Kopiuj tagi</b-button>
                <b-button size="sm" class="mt-1" @click="pasteTags">Wklej tagi</b-button>
                <div class="tag-copy-paste-hint mt-1 ml-1">Format kopiowanych/wklejanych tagów - nazwy oddzielone średnikami: <i>Tag 1; Tag 2; Tag 3</i></div>
                <div class="tag-legend">
                    <div class="tag-legend-row">
                        <div class="players-age"></div>Wiek graczy
                    </div>
                    <div class="tag-legend-row">
                        <div class="number-of-players"></div>Ilość graczy
                    </div>
                    <div class="tag-legend-row">
                        <div class="operational-goals"></div>Cele operacyjne
                    </div>
                    <div class="tag-legend-row">
                        <div class="thematic-categories"></div>Kategorie tematyczne
                    </div>

                </div>
            </div>

        </form>
    </b-modal>

</template>

<script>

    import {inputValidators} from '../../mixins/inputValidators';
    import Image from "../../../../../../FileManager/Resources/assets/js/classes/Image";

    export default {

        name: 'GameLibraryGameModal',

        mixins: [inputValidators],

        props: [
            'repo',
            'library',
            'setLocations',
            'editors'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                action: null,
                id: null,
                form: new Vue.prototype.Form({
                    set_id: null,
                    input_identification_name: null,
                    output_identification_name: null,
                    display_name: null,
                    display_description: null,
                    icon: null,
                    autoenter: false,
                    presentation_game: false,
                    editor: null,
                    tags_ids: [],
                }),
                editorOptions: [],
                tags: [],
                tagCategoryColors: {
                    players_age: '#00a97f',
                    number_of_players: '#5151a6',
                    operational_goals: '#cd975a',
                    thematic_categories: '#cd5a77'
                },
                tagsSelect2Settings: {
                    closeOnSelect: false,
                    templateSelection: function (data, container) {
                        $(container).css("color", "white");
                        $(container).css("background-color", data.color);
                        return data.text;
                    },
                    templateResult: function (data, container) {
                        $(container).css("background-color", data.color);
                        return data.text;
                    },
                }
            }
        },

        computed: {
            packageLanguage: function () {
                let packageLanguage = null;

                for (let areaIndex = 0; areaIndex < this.library.length; areaIndex++) {
                    let area = this.library[areaIndex];
                    for (let packageIndex = 0; packageIndex < area.packages.length; packageIndex++) {
                        let package_ = area.packages[packageIndex];
                        for (let setIndex = 0; setIndex < package_.sets.length; setIndex++) {
                            let set = package_.sets[setIndex];
                            if (set.id === this.form.set_id) {
                                packageLanguage = package_.language;
                            }
                        }
                        if (packageLanguage !== null) {
                            break;
                        }
                    }
                    if (packageLanguage !== null) {
                        break;
                    }
                }

                return packageLanguage;
            },
            tagsOptions: function () {
                let tagsOrder = [
                    'players_age',
                    'number_of_players',
                    'operational_goals',
                    'thematic_categories',
                ];
                let tagsOrderNumberOfPlayers = [
                    '1 gracz',
                    '2 graczy',
                    '4 graczy',
                    'Mała grupa (3-5 graczy)',
                    'Duża grupa ( pow. 6 graczy)'
                ];
                let tagsOrderPlayersAge = [
                    '6 miesięcy',
                    '1 rok',
                    '2 lata',
                    '3 lata',
                    '4 lata',
                    '5 lat',
                    '6 lat',
                    '7 lat',
                    '8 lat',
                    '9 lat',
                    '10 lat',
                    '11 lat',
                    '12 lat',
                    '13 lat',
                    '14 lat',
                    '15 lat',
                    '16 lat',
                    '17 lat',
                    '18-65 lat',
                    '66-120 lat'
                ];
                let tags = this.tags;
                tags.sort((tagA, tagB) => tagsOrder.indexOf(tagA.category) - tagsOrder.indexOf(tagB.category));
                tags.sort((tagA, tagB) => {
                    if (tagA.category !== tagB.category) {
                        return 0;
                    }
                    if (tagA.category === 'number_of_players') {
                        return tagsOrderNumberOfPlayers.indexOf(tagA.name) - tagsOrderNumberOfPlayers.indexOf(tagB.name);
                    }
                    if (tagA.category === 'players_age') {
                        return tagsOrderPlayersAge.indexOf(tagA.name) - tagsOrderPlayersAge.indexOf(tagB.name);
                    }
                    return 0;
                });
                let tagsOptions = [];
                tags.forEach(tag => {
                    tagsOptions.push({
                        text: tag.name,
                        id: tag.id,
                        color: this.tagCategoryColors[tag.category]
                    });
                });
                return tagsOptions;
            }
        },

        beforeMount() {

            this.editorOptions = Object.keys(this.editors).map(identifier => {
               return {
                   id: identifier,
                   text: this.editors[identifier]
               };
            });

        },

        mounted() {

            // Set variables and show modal in add state
            this.eventHub.$on('game-library-add-game', (inputIdentificationName, setId = null) => {

                this.eventHub.$emit('processing-start');

                this.action = 'add';
                this.id = null;
                this.form = new Vue.prototype.Form({
                    set_id: setId,
                    input_identification_name: inputIdentificationName,
                    output_identification_name: null,
                    display_name: this.addGameDisplayName(inputIdentificationName),
                    display_description: null,
                    icon: null,
                    autoenter: false,
                    presentation_game: false,
                    ignore_screensaver: false,
                    editor: null,
                    tags_ids: []
                });

                axios.get(route('game::game-library.get-tags'))
                    .then(response => {
                        this.tags = response.data.data.tags;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('game-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    });

            });

            // Set variables and show modal in edit state
            this.eventHub.$on('game-library-edit-game', (game) => {

                this.eventHub.$emit('processing-start');

                this.action = 'edit';
                this.id = game.id;
                this.form = new Vue.prototype.Form({
                    set_id: game.set_id,
                    input_identification_name: game.input_identification_name,
                    output_identification_name: game.output_identification_name,
                    display_name: game.display_name,
                    display_description: game.display_description,
                    icon: new Image(game.icon_url),
                    autoenter: game.autoenter,
                    presentation_game: game.presentation_game,
                    ignore_screensaver: game.ignore_screensaver,
                    editor: game.editor,
                    tags_ids: game.tags.map(tag => tag.id),
                });

                axios.get(route('game::game-library.get-tags'))
                    .then(response => {
                        this.tags = response.data.data.tags;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('game-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    });

            });

        },

        methods: {

            gameModalHandleOk(event) {
                event.preventDefault();
                this.submitGameForm();
            },

            gameModalHandleHide() {
                this.action = null;
                this.id = null;
                this.form = new Vue.prototype.Form({
                    set_id: null,
                    input_identification_name: null,
                    output_identification_name: null,
                    display_name: null,
                    display_description: null,
                    icon: null,
                    autoenter: false,
                    presentation_game: false,
                    ignore_screensaver: false,
                    editor: null,
                    tags_ids: []
                });
            },

            submitGameForm() {
                this.eventHub.$emit('processing-start');
                if (this.action === 'add') {
                    // this.form.post(route('game::game-library.store-game', {repo: this.repo}))
                    this.form.post(route('game::game-library.store-game', {repo: 'dev'}))
                        .then(response => {
                            this.eventHub.$emit('game-library-updated', response.data.library);
                            this.$bvModal.hide('game-modal');
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                        });
                } else if (this.action === 'edit') {
                    this.form.put(route('game::game-library.update-game', {repo: 'dev', id: this.id}))
                        .then(response => {
                            this.eventHub.$emit('game-library-updated', response.data.library);
                            this.$bvModal.hide('game-modal');
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                        });
                }

            },

            addGameDisplayName(inputIdentificationName) {
                if (inputIdentificationName) {
                    let inputIdentificationNameParts = inputIdentificationName.split('/');
                    return inputIdentificationNameParts[inputIdentificationNameParts.length - 1];
                }
                return '';
            },

            setGameOutputIdentifierName() {
                if (this.form.output_identification_name) {
                    return;
                }
                this.form.output_identification_name = this.form.display_name.toLowerCase().replace(' ', '-');
            },

            loadIconFromRawRepository() {
                this.eventHub.$emit('processing-start');
                axios.get(route('game::game-library.get-source-game-icon-data', {repo: this.repo, 'input-identification-name': this.form.input_identification_name}))
                    .then(response => {
                        this.form.icon = new Image(response.data.data.webPath);
                        this.form.icon.setNewImageData({
                            webPath: response.data.data.webPath,
                            fullPath: response.data.data.fullPath,
                            customSource: response.data.data.customSource
                        });
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                    });
            },

            async copyTags() {
                let tagNames = [];
                this.form.tags_ids.forEach(tagId => {
                    let tag = this.tags.find(t => {
                        return t.id === parseInt(tagId);
                    });
                    tagNames.push(tag.name);
                });
                let tagNamesStr = tagNames.join('; ');
                console.log(tagNamesStr);
                try {
                    await navigator.clipboard.writeText(tagNamesStr);
                } catch (e) {
                    console.log(e);
                }
            },

            pasteTags() {
                try {
                    navigator.clipboard.readText()
                        .then(content => {
                            console.log(content);
                            let names = content.split(';');
                            names.forEach(name => {
                                let tag = this.tags.find(t => {
                                    return t.name === name.trim();
                                });
                                if (!this.form.tags_ids.includes(tag.id)) {
                                    this.form.tags_ids.push(tag.id);
                                }
                            });
                        })
                        .catch(e => {
                            console.error(e);
                        });
                } catch (e) {
                    console.log(e);
                }
            }

        }

    }
</script>

<style scoped>

    .load-icon-from-raw-repo {
        font-size: 0.875rem;
    }

    .tag-legend {
        margin-top: 10px;
    }

    .tag-legend .tag-legend-row {
        display: flex;
        align-items: center;
        margin-top: 3px;
        font-size: 80%;
        font-weight: 400;
    }

    .tag-legend .tag-legend-row div {
        height: 15px;
        width: 15px;
        margin-right: 5px;
    }

    .tag-legend .tag-legend-row div.players-age {
        background-color: #00a97f;
    }

    .tag-legend .tag-legend-row div.number-of-players {
        background-color: #5151a6;
    }

    .tag-legend .tag-legend-row div.operational-goals {
        background-color: #cd975a;
    }

    .tag-legend .tag-legend-row div.thematic-categories {
        background-color: #cd5a77;
    }

    .tag-copy-paste-hint {
        display: inline-block;
        line-height: 30px;
        color: #8d9498;
        font-size: 80%;
        font-weight: 400;
    }

</style>
